var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details col-xs-9 col-sm-10" }, [
    _c("div", { staticClass: "details-wrapper" }, [
      _c("div", { staticClass: "first-row" }, [
        _vm.flightdirection === "outward"
          ? _c("div", [
              _c("h4", { staticClass: "box-title" }, [
                _vm._v(
                  _vm._s(_vm.flight.depArprt.i) +
                    " " +
                    _vm._s(_vm.to[_vm.getCurrentLocale]) +
                    " " +
                    _vm._s(_vm.flight.desArprt.i)
                ),
                _c("small", [
                  _vm._v(
                    _vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i)) +
                      " - " +
                      _vm._s(_vm.flight.no)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button btn-mini silver",
                  class: {
                    yellow:
                      _vm.get_RebookingFlightIdSelectedOutward ===
                      _vm.flight.id,
                  },
                  staticStyle: {
                    cursor: "initial",
                    outline: "none !important",
                    "outline-style": "none !important",
                  },
                },
                [
                  _vm._v(
                    "STOPS: " + _vm._s(_vm.flight.stpArprt === null ? "0" : "1")
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.flightdirection === "return"
          ? _c("div", [
              _c("h4", { staticClass: "box-title" }, [
                _vm._v(
                  _vm._s(_vm.flight.depArprt.i) +
                    " " +
                    _vm._s(_vm.to[_vm.getCurrentLocale]) +
                    " " +
                    _vm._s(_vm.flight.desArprt.i)
                ),
                _c("small", [
                  _vm._v(
                    _vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i)) +
                      " - " +
                      _vm._s(_vm.flight.no)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button btn-mini silver",
                  class: {
                    yellow:
                      _vm.get_RebookingFlightIdSelectedReturn === _vm.flight.id,
                  },
                  staticStyle: {
                    cursor: "initial",
                    outline: "none !important",
                    "outline-style": "none !important",
                  },
                },
                [
                  _vm._v(
                    "STOPS: " + _vm._s(_vm.flight.stpArprt === null ? "0" : "1")
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _vm.flight.prcs[0] !== undefined
            ? _c("span", { staticClass: "price" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.seetaxes[_vm.getCurrentLocale],
                        expression: "seetaxes[getCurrentLocale]",
                      },
                    ],
                    staticClass: "collapsed",
                    attrs: {
                      href: "#acc" + _vm.flight.id,
                      "data-toggle": "collapse",
                      "data-parent": "#accordion" + _vm.flight.id,
                    },
                  },
                  [
                    _c("small", [
                      _vm._v(_vm._s(_vm.avgpers[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm._f("rndAmntRUAFWZ")(
                          Number(_vm.flight.prcs[0].amnt) +
                            Number(_vm.flight.prcs[0].tax.tot)
                        )
                      ) + "\n                    "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.flight.prcs[0] === undefined
            ? _c(
                "span",
                {
                  staticClass: "price",
                  staticStyle: { color: "#D9D9D8", "text-transform": "none" },
                },
                [
                  _c("small", { staticStyle: { color: "#D9D9D8" } }, [
                    _vm._v(_vm._s(_vm.avgpers[_vm.getCurrentLocale])),
                  ]),
                  _c("span", { staticStyle: { color: "rgb(142, 142, 142)" } }, [
                    _vm._v(_vm._s(_vm.out[_vm.getCurrentLocale])),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "second-row" }, [
        _c("div", { staticClass: "time" }, [
          _c("div", { staticClass: "take-off col-sm-4" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                        " +
                  _vm._s(_vm._f("moment")(_vm.flight.depDT)) +
                  "\n                    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing col-sm-4" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                        " +
                  _vm._s(_vm._f("moment")(_vm.flight.desDT)) +
                  "\n                    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-time col-sm-4" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.totaltime[_vm.getCurrentLocale])),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                        " +
                  _vm._s(_vm._f("durationFlight")(_vm.flight.dur)) +
                  "\n                    "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.flight.prcs[0] !== undefined && _vm.flightdirection === "outward"
          ? _c("div", { staticClass: "action" }, [
              _vm.get_RebookingFlightIdSelectedOutward !== _vm.flight.id
                ? _c(
                    "a",
                    {
                      staticClass: "button btn-small full-width xgreen",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.onClick_SelectFlight({
                            flight: _vm.flight,
                            type: "outward",
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.selectflight[_vm.getCurrentLocale]) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.get_RebookingFlightIdSelectedOutward === _vm.flight.id
                ? _c(
                    "a",
                    { staticClass: "button btn-small full-width sundair" },
                    [_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.flight.prcs[0] !== undefined && _vm.flightdirection === "return"
          ? _c("div", { staticClass: "action" }, [
              _vm.get_RebookingFlightIdSelectedReturn !== _vm.flight.id
                ? _c(
                    "a",
                    {
                      staticClass: "button btn-small full-width xgreen",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.onClick_SelectFlight({
                            flight: _vm.flight,
                            type: "return",
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.selectflight[_vm.getCurrentLocale]) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.get_RebookingFlightIdSelectedReturn === _vm.flight.id
                ? _c(
                    "a",
                    { staticClass: "button btn-small full-width sundair" },
                    [_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.flight.prcs[0] === undefined
          ? _c("div", { staticClass: "action" }, [
              _c(
                "a",
                {
                  staticClass: "button btn-small full-width silver",
                  staticStyle: {
                    color: "rgba(0,0,0,.075)",
                    background: "#F9F9F9",
                  },
                },
                [_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.flight.prcs[0] !== undefined
      ? _c(
          "div",
          { staticClass: "row", staticStyle: { "margin-bottom": "0px" } },
          [
            _c(
              "div",
              {
                staticClass: "toggle-container",
                attrs: { id: "accordion" + _vm.flight.id },
              },
              [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "acc" + _vm.flight.id },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "panel-content",
                          staticStyle: {
                            "padding-top": "0px",
                            "padding-left": "15px",
                          },
                        },
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.taxesandfees[_vm.getCurrentLocale]) +
                                ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "0px",
                                "padding-right": "10px",
                                "margin-bottom": "0px",
                                width: "50%",
                              },
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticStyle: {
                                    "margin-bottom": "0px",
                                    "font-size": "0.8333em",
                                  },
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.airfare[_vm.getCurrentLocale]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                Number(_vm.flight.prcs[0].amnt)
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.airporttaxes[_vm.getCurrentLocale]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                _vm.flight.prcs[0].tax.air
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.aviationtax[_vm.getCurrentLocale]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                _vm.flight.prcs[0].tax.avia
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.kerosenesurcharge[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                _vm.flight.prcs[0].tax.fuel
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.securitycharges[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                _vm.flight.prcs[0].tax.sec
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "skin-color uppercase" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.servicecharges[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                _vm.flight.prcs[0].tax.srvc
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "amenities" }, [
      _c("i", { staticClass: "soap-icon-passenger circle greychossen" }),
      _vm._v(" "),
      _c("i", { staticClass: "soap-icon-fork circle greychossen" }),
      _vm._v(" "),
      _c("i", { staticClass: "soap-icon-suitcase circle greychossen" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "amenities" }, [
      _c("i", { staticClass: "soap-icon-passenger circle greychossen" }),
      _vm._v(" "),
      _c("i", { staticClass: "soap-icon-fork circle greychossen" }),
      _vm._v(" "),
      _c("i", { staticClass: "soap-icon-suitcase circle greychossen" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "soap-icon-plane-right yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "soap-icon-plane-right yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "soap-icon-clock yellow-color" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }